export class IPack{
  packCreationDate! : Date;
  packMonth! : number;
  packYear! : number;
  packCommandYear! : number;

}
